import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.z3q_1 = user;
        this.a3r_1 = authenticated;
        this.b3r_1 = loading;
        this.c3r_1 = error;
        this.d3r_1 = loginWithRedirect;
        this.e3r_1 = getIdTokenClaims;
        this.f3r_1 = logout;
        this.g3r_1 = getAccessTokenSilently;
      }
      xe() {
        return this.a3r_1;
      }
      h3r() {
        return this.b3r_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.z3q_1) + ', authenticated=' + this.a3r_1 + ', loading=' + this.b3r_1 + ', error=' + toString(this.c3r_1) + ', loginWithRedirect=' + toString_0(this.d3r_1) + ', getIdTokenClaims=' + toString_0(this.e3r_1) + ', logout=' + toString_0(this.f3r_1) + ', getAccessTokenSilently=' + toString_0(this.g3r_1) + ')';
      }
      hashCode() {
        var result = this.z3q_1 == null ? 0 : hashCode(this.z3q_1);
        result = imul(result, 31) + getBooleanHashCode(this.a3r_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.b3r_1) | 0;
        result = imul(result, 31) + (this.c3r_1 == null ? 0 : hashCode(this.c3r_1)) | 0;
        result = imul(result, 31) + hashCode(this.d3r_1) | 0;
        result = imul(result, 31) + hashCode(this.e3r_1) | 0;
        result = imul(result, 31) + hashCode(this.f3r_1) | 0;
        result = imul(result, 31) + hashCode(this.g3r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.z3q_1, other.z3q_1))
          return false;
        if (!(this.a3r_1 === other.a3r_1))
          return false;
        if (!(this.b3r_1 === other.b3r_1))
          return false;
        if (!equals(this.c3r_1, other.c3r_1))
          return false;
        if (!equals(this.d3r_1, other.d3r_1))
          return false;
        if (!equals(this.e3r_1, other.e3r_1))
          return false;
        if (!equals(this.f3r_1, other.f3r_1))
          return false;
        if (!equals(this.g3r_1, other.g3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
